var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showHeader,
            expression: "showHeader",
          },
        ],
        staticClass: "list-control mt-n2 mx-n2 pt-2 px-2 mb-2",
      },
      [
        _vm.topBarEnabled
          ? _c(
              "b-row",
              { staticClass: "search-input" },
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { md: _vm.searchWidgetWidth } },
                  [
                    _c(
                      "b-form-group",
                      { staticClass: "mb-0" },
                      [
                        _c(
                          "b-input-group",
                          [
                            _vm.categories.length > 0
                              ? _c(
                                  "b-input-group-prepend",
                                  { staticClass: "category-filter" },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.categories,
                                        "text-field": "name",
                                        "value-field": "id",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "option",
                                                  {
                                                    staticClass: "placeholder",
                                                    domProps: { value: null },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "product.category.filter"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3778688401
                                      ),
                                      model: {
                                        value: _vm.selectedCategory,
                                        callback: function ($$v) {
                                          _vm.selectedCategory = $$v
                                        },
                                        expression: "selectedCategory",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("b-form-input", {
                              ref: "searchField",
                              attrs: {
                                autocomplete: "off",
                                autofocus: _vm.selector,
                                disabled: _vm.searchBarDisabled,
                                placeholder: _vm._f("trans")(
                                  "frontend.type-to-search"
                                ),
                              },
                              on: {
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "down",
                                        40,
                                        $event.key,
                                        ["Down", "ArrowDown"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.itemDown.apply(null, arguments)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.emitSelected.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.clearSearch.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "up",
                                        38,
                                        $event.key,
                                        ["Up", "ArrowUp"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.itemUp.apply(null, arguments)
                                  },
                                ],
                              },
                              model: {
                                value: _vm.searchString,
                                callback: function ($$v) {
                                  _vm.searchString = $$v
                                },
                                expression: "searchString",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.searchString,
                                      variant: "outline-secondary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.searchString = ""
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-trash-alt",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("trans")("frontend.clear")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.selector
                  ? _c(
                      "b-col",
                      { staticClass: "mb-1", attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: {
                              label: _vm._f("trans")("frontend.per-page"),
                              "label-cols-lg": "2",
                              "label-cols-md": "3",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                disabled: _vm.rows <= _vm.pageOptions[0],
                                options: _vm.pageOptions,
                              },
                              model: {
                                value: _vm.perPage,
                                callback: function ($$v) {
                                  _vm.perPage = $$v
                                },
                                expression: "perPage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "status d-flex flex-wrap" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.rows > 0,
                  expression: "rows > 0",
                },
              ],
              staticClass: "align-self-center mr-2 mb-1",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("trans")("frontend.table.pagination", {
                      start: _vm.start,
                      end: _vm.end,
                      rows: _vm.rows,
                    })
                  ) +
                  "\n        "
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.selector &&
                        _vm.searchString &&
                        _vm.initialData.length !== _vm.rows,
                      expression:
                        "!selector && searchString && initialData.length !== rows",
                    },
                  ],
                },
                [
                  _vm._v(
                    "\n          (" +
                      _vm._s(_vm._f("trans")("frontend.table.filtered")) +
                      ")\n        "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.searching &&
                    _vm.items.length !== 0 &&
                    _vm.searchString !== "",
                  expression:
                    "searching && items.length !== 0 && searchString !== ''",
                },
              ],
              staticClass: "align-self-center mb-1",
            },
            [
              _c("i", { staticClass: "fas fa-fw fa-circle-notch fa-spin" }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("trans")("frontend.searching")) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isLoading && !_vm.hasError && _vm.rows > _vm.perPage,
                  expression: "!isLoading && !hasError && rows > perPage",
                },
              ],
              staticClass: "ml-auto mb-1",
            },
            [
              _c("b-pagination", {
                attrs: {
                  "aria-controls": "my-table",
                  limit: 10,
                  "per-page": _vm.perPage,
                  "total-rows": _vm.rows,
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overflow-auto position-relative" },
      [
        _c("StoresTable", {
          ref: "table",
          attrs: {
            busy: _vm.isLoading || _vm.hasError,
            "current-page": _vm.currentPage,
            "error-text": _vm.errorText,
            fields: _vm.fields,
            filter: _vm.filter,
            hover: "",
            "is-loading": _vm.isLoading,
            items: _vm.items,
            "per-page": _vm.perPage,
            "primary-key": _vm.resolvedPrimaryKey,
            "select-mode": "single",
            selectable: _vm.selector,
            "show-empty": "",
            small: "",
            "sort-by": _vm.sortBy,
            "sort-desc": _vm.sortDesc,
            "sort-null-last": _vm.sortNullLast,
            stacked: _vm.stacked,
            striped: "",
          },
          on: {
            "update:sortBy": function ($event) {
              _vm.sortBy = $event
            },
            "update:sort-by": function ($event) {
              _vm.sortBy = $event
            },
            "update:sortDesc": function ($event) {
              _vm.sortDesc = $event
            },
            "update:sort-desc": function ($event) {
              _vm.sortDesc = $event
            },
            filtered: _vm.onFiltered,
            "row-hovered": _vm.onRowHover,
            "row-selected": _vm.onRowSelected,
            "sort-changed": function ($event) {
              return _vm.highlightItem(0)
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "empty",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center my-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")(_vm.emptyText)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "emptyfiltered",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center my-2" }, [
                      _vm.searchUrl !== ""
                        ? _c("i", {
                            staticClass: "fas fa-fw fa-circle-notch fa-spin",
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("trans")(_vm.emptyFilterText)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        _vm._t("extra_actions", null, null, data),
                        _vm._v(" "),
                        _vm.editUrl || _vm.editShown
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  href: _vm._f("path")(_vm.editUrl, {
                                    item: data.item[_vm.identityField],
                                  }),
                                  variant: "outline-secondary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editClick(data.item)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-fw fa-edit" }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm._f("trans")("form.edit")) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.removeUrl !== "" || _vm.removeShown
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  href: _vm._f("path")(_vm.removeUrl, {
                                    item: data.item[_vm.identityField],
                                  }),
                                  variant: "outline-danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeClick(data.item)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-fw fa-trash-alt",
                                }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm._f("trans")("form.remove")) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "cell(thumb)",
                fn: function (data) {
                  return [
                    _c("img", {
                      staticClass: "table-thumb",
                      attrs: {
                        alt: _vm._f("trans")("product.image"),
                        src: data.value,
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(sale_price)",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("currency")(data.value)) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(email_address)",
                fn: function (data) {
                  return [
                    _c("a", { attrs: { href: "mailto:" + data.value } }, [
                      _vm._v(_vm._s(data.value)),
                    ]),
                  ]
                },
              },
              {
                key: "cell(website)",
                fn: function (data) {
                  return [
                    _c("a", { attrs: { href: data.value, target: "_blank" } }, [
                      _vm._v(_vm._s(data.value)),
                    ]),
                  ]
                },
              },
              {
                key: "cell(person_type)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("trans")(`person.type.${row.value}`)) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(invoice_type)",
                fn: function (row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("trans")("person.invoice-type." + row.value)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
              _vm._l(_vm.$scopedSlots, function (_, slot) {
                return {
                  key: slot,
                  fn: function (scope) {
                    return [_vm._t(slot, null, null, scope)]
                  },
                }
              }),
            ],
            null,
            true
          ),
          model: {
            value: _vm.displayedItems,
            callback: function ($$v) {
              _vm.displayedItems = $$v
            },
            expression: "displayedItems",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }